import { useLoaderData } from '@remix-run/react'
import { deconstructNode } from '~/libs/contentful/helpers'
import { JobTitlePageLoaderData } from '~/routes/careers.$slug.$type'
import { TypeSalaryByExperience } from '~/types/contentful/TypeSalaryByExperience'
import { ExperienceLevelLabels, ExperienceLevels } from '~/types/salary-data'

type SalaryByExperienceProps = {
  salaryByExperience: TypeSalaryByExperience<undefined, string>
}

export const SalaryByExperience = ({ salaryByExperience }: SalaryByExperienceProps) => {
  const { salaryData } = useLoaderData() as Pick<JobTitlePageLoaderData, 'salaryData'>
  if (!salaryData) return null

  const { experience_level_salary } = salaryData.data
  if (!experience_level_salary) return null

  const topSalary =
    experience_level_salary['10+'] ||
    experience_level_salary['6to9'] ||
    experience_level_salary['3to6'] ||
    experience_level_salary['1to3'] ||
    experience_level_salary['Fresher']

  const { fields } = deconstructNode(salaryByExperience) as TypeSalaryByExperience<
    undefined,
    string
  >
  const { jobTitle, description } = fields
  return (
    <div className="flex flex-col items-start gap-3 self-stretch my-12">
      <span className="text-m text-neutral-100 self-stretch">{jobTitle} Salary by Experience</span>
      <span className="text-xs text-neutral-60 self-stretch">{description}</span>
      <ul className="flex flex-col items-start gap-3 self-stretch">
        {ExperienceLevels.map((experience, index) => {
          const salary = experience_level_salary[experience] || undefined
          if (!salary) return null

          return (
            <li
              key={index}
              className="flex py-2 px-4 items-center justify-between gap-2 rounded bg-blue-10 self-stretch text-xs text-neutral-100"
              style={{
                width: `${(salary / topSalary) * 100}%`,
              }}
            >
              <span className="text-neutral-60">{ExperienceLevelLabels[experience]}</span>
              <span>${salary}</span>
            </li>
          )
        })}
      </ul>
      <span className="text-[16px] leading-5 text-neutral-60 self-stretch">
        Note: These figures represent average salaries and may vary based on location, company size,
        and industry.
      </span>
    </div>
  )
}
